<div class="custom_toast" [class.show]="_toast.isVisible" [id]="localToastId">
    <div class="toast-dialog">
        <div [ngClass]="_toast.type" class="toast-content shadow-lg">
            <div class="row g-0 align-items-start">
                <div class="col-auto toast_icon ms-3">
                    <i [ngClass]="_toast.icon"></i>
                </div>
                <div class="col toast_msg">
                    <div class="d-grid">
                        <p class="p-0 m-0 mb-1 fw-semibold">{{ _toast.title }}</p>
                        <small class="p-0 m-0">{{ _toast.message }}</small>
                    </div>
                </div>
                <div class="col-auto toast_close pe-2">
                    <a (click)="_toast.HideToast()">
                        <i class="fi fi-rr-cross-small pointer"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
